import { Module, ActionTree, MutationTree, GetterTree } from 'vuex';
import { GlobalState } from '../types';
import { StartLinksState, StartLink } from './types';
import * as myetaapi from '@/api/myeta';

export const state: StartLinksState = {
    startLinks: []
};

export const actions: ActionTree<StartLinksState, GlobalState> = {
    async reload({ commit, getters }, param) {
        const startLinks = await myetaapi.getStartLinks(param);
        commit('setStartLinks', {
            startLinks
        });
    },

    async create({ commit }, payload) {
        const startLink = await myetaapi.createStartLink(payload.destinationId, payload.name);
        commit('startLinkCreated');
    },

    async retire({ commit }, payload) {
        //await myetaapi.retireStartLink(payload);
        commit('startLinkRetired');
    },
};

export const mutations: MutationTree<StartLinksState> = {
    setStartLinks(state, payload) {
        state.startLinks = payload.startLinks;
        console.log('set start links', state.startLinks);
    },

    startLinkCreated(state, payload) {
        console.log('start link created');
    },

    startLinkRetired(state, payload) {
        console.log('start link retired');
    },
};

export const getters: GetterTree<StartLinksState, GlobalState> = {
    currentStartLinks(state): StartLink[] | null {
        return state.startLinks;
    },
};

const namespaced: boolean = true;
export const links: Module<StartLinksState, GlobalState> = {
    namespaced,
    state,
    actions,
    mutations,
    getters,
};
